import { css } from 'styled-system/css';

export const Styles = {
	bettype: css({
		_mars: {
			backgroundColor: 'bettype.content.bg',
			'&[data-open="false"] .bettype__header': {
				borderRadius: '6px',
			},
			'&[data-inplay="true"]': {
				border: '1px solid {colors.bettype.inplay.bg}',
				'& .bettype__header': {
					backgroundColor: 'bettype.inplay.bg!',
					'& .bettype__header-text, .icon--dropdown': {
						color: 'bettype.inplay.text',
					},
				},
				'& .bettype__content-special .bettype__heading': {
					backgroundColor: 'transparent',
				},
			},
			'&.bettype--43': {
				'& .bettype__header': {
					borderBottom: '1px solid {colors.black.5}',
				},
				'& .bettype__header, .bettype__heading, .bettype__header-special': {
					backgroundColor: 'bettype.category.bg_43',
				},
				'& .bettype__header-special': {
					color: 'black.2',
				},
				'& .bettype__content-special + .bettype__content-special': {
					borderTop: '1px solid {colors.black.5}',
				},
			},
			'& .bettype__header': {
				color: 'bettype.header.text',
				backgroundColor: 'bettype.header.bg',
				minHeight: '32px',
				borderTopLeftRadius: '6px',
				borderTopRightRadius: '6px',
				borderBottom: 'none',
			},
			'& .bettype__header-icons': {
				'& .btn--icon': {
					color: 'black.3',
					_hover: {
						color: 'primary.500',
					},
					'&[data-active=true] > .icon--pin': {
						color: 'warning.base',
						filter: 'drop-shadow(0 0 9px currentColor)'
					}
				},
				'& .icon--dropdown': {
					color: 'bettype.header.text',
				}
			},
			'& .bettype__content': {
				// Cricket
				'&.bettype__content--cricket-back-lay': {
					'& .bettype__title:nth-child(2)': {
						color: 'oddsButton.backYesBorder',
					},
					'& .bettype__title:nth-child(3)': {
						color: 'oddsButton.layNoBorder',
					},
				},
				'&.bettype__content--cricket-no-yes': {
					'& .bettype__title:nth-child(2)': {
						color: 'oddsButton.layNoBorder',
					},
					'& .bettype__title:nth-child(3)': {
						color: 'oddsButton.backYesBorder',
					},
				},
			},
			'& .bettype__content--group-row-mars .bettype__group': {
				gridTemplateColumns: '2.5fr 1fr 1fr 1fr',
				'& + .bettype__group::before': {
					w: '55%',
				},
				md: {
					gridTemplateColumns: '4fr 1fr 1fr 1fr',
					'& + .bettype__group::before': {
						w: '43.6%',
					}
				}
			},
			'& .bettype__title': {
				fontSize: '14px',
				color: 'black.2',
				fontWeight: '500',
			},
			'& .bettype__text': {
				fontSize: '14px',
				color: 'black.2',
				fontWeight: '500',
			},
			'& .bettype__filter': {
				gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
			},
			'& .bettype__content--set-x-cs .bettype__filter': {
				gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
			},
			'& .bettype__filter-content': {
				borderTop: '3px solid var(--s800)'
			},
			'& .bettype__more': {
				color: 'bettype.activeText',
				gridColumn: 'initial',
				fontSize: '12px',
				lineHeight: '15px',
				textAlign: 'center',
				padding: 0,
				boxShadow: 'inset 0 0 0 1px {colors.oddsTable.border}',
				borderRadius: '6px',
				'& .bettype__more-text': {
					lineHeight: 'inherit',
				},
				'& .icon': {
					display: 'none',
				},
			},
			'& .bettype__header-special': {
				m: '6px',
				borderRadius: '6px',
				color: 'black.1',
				backgroundColor: 'bettype.headerSpecial.bg',
				'& .bettype-home, .bettype-away': {
					fontWeight: '500',
				},
				'& .bettype-score': {
					color: 'secondary.500',
				},
			},
			'& .bettype__heading': {
				borderTop: '1px solid {colors.black.5}',
				color: 'bettype.headerSpecial.text',
			},
			'& .dropdown__btn': {
				color: 'black.2',
				backgroundColor: 'oddsTable.bg',
				boxShadow: 'inset 0 0 0 1px {colors.oddsTable.border}',
			},
			'& .dropdown__current': {
				color: 'black.2',
			},
			'& .dropdown__container': {
				minWidth: '150px',
				
				'& .scrollbar': {
					px: '6px',
				}
			},
			'& .dropdown__item': {
				color: 'black.1',
				fontWeight: '400',
				'&[data-selected="true"]': {
					color: 'bettype.activeText',
					fontWeight: '700',
					backgroundColor: 'transparent',
					_after: {
						content: '""',
						// position: 'absolute',
						// top: 0,
						// right: 0,
						ml: 'auto',
						mr: '-12px',
						w: '24px',
						h: '24px',
						backgroundColor: 'currentcolor',
						maskImage: 'url(data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M10.421%2016.663c.323%200%20.647-.13.893-.39l6.316-6.667c.217-.23.37-.547.37-.943%200-.729-.57-1.333-1.263-1.333-.323%200-.647.13-.893.39l-5.423%205.725-2.265-2.391c-.246-.26-.57-.39-.893-.39-.693%200-1.263.603-1.263%201.333%200%20.396.153.713.37.942l3.158%203.334c.246.26.57.39.893.39Z%22%2F%3E%3C%2Fsvg%3E)',

					}
				},
			}
		}
	}),
	bettypeHeader: css({
		_mars: {
			position: 'relative',
			overflow: 'hidden',
			_before: {
				content: '""',
				width: '80%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: '-10%',
				backgroundImage: 'linear-gradient(90deg, token(colors.bettype.header.gradientFrom), token(colors.bettype.header.gradientTo) 60%)',
				transform: 'skewX(-30deg)',
			},
			_after: {
				content: '""',
				width: '5px',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 'calc(70% + 6px)',
				backgroundColor: 'bettype.header.gradientTo',
				transform: 'skewX(-30deg)',
			}
		},
	}),
	bettypeHeaderText: css({
		_mars: {
			position: 'relative',
			zIndex: 1,
		}
	}),
	childMatchLeagueHeader: css({
		_mars: {
			bgColor: 'transparent!',
		}
	}),
	childMatchBettypeHeader: css({
		_mars: {
			backgroundColor: 'bettype.childMatchHeader.bg',
		}
	}),
}